import { render } from "./MyAddresses.vue?vue&type=template&id=1fc265fc&scoped=true"
import script from "./MyAddresses.vue?vue&type=script&lang=js"
export * from "./MyAddresses.vue?vue&type=script&lang=js"

import "./MyAddresses.vue?vue&type=style&index=0&id=1fc265fc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc265fc"]])

export default __exports__